  (() => {
    if (window.BeeProductStoryShareFinalReady) return;
    window.BeeProductStoryShareFinalReady = true;

    let alignmentFrame;

    function alignShareButtons() {
      document.querySelectorAll('[data-product-story-share]').forEach((root) => {
        const wrapper = root.closest('.bee-product__media-wrapper');
        if (!wrapper) return;

        const iconButtons = Array.from(wrapper.querySelectorAll('.bee-pr__icon-btn')).filter((button) => {
          if (root.contains(button)) return false;

          const rect = button.getBoundingClientRect();
          const style = window.getComputedStyle(button);
          return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
        });

        if (!iconButtons.length) {
          root.removeAttribute('data-icon-aligned');
          return;
        }

        const reference = iconButtons.sort((first, second) => {
          const firstRect = first.getBoundingClientRect();
          const secondRect = second.getBoundingClientRect();
          return secondRect.right - firstRect.right || secondRect.bottom - firstRect.bottom;
        })[0];
        const wrapperRect = wrapper.getBoundingClientRect();
        const referenceRect = reference.getBoundingClientRect();

        root.style.setProperty('--bee-story-share-top', `${referenceRect.top - wrapperRect.top}px`);
        root.style.setProperty('--bee-story-share-width', `${referenceRect.width}px`);
        root.style.setProperty('--bee-story-share-height', `${referenceRect.height}px`);
        root.setAttribute('data-icon-aligned', 'true');
      });
    }

    function scheduleShareAlignment() {
      window.cancelAnimationFrame(alignmentFrame);
      alignmentFrame = window.requestAnimationFrame(alignShareButtons);
    }

    function loadImage(url) {
      return new Promise((resolve, reject) => {
        if (!url) {
          reject(new Error('Image URL is empty'));
          return;
        }

        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = new URL(url, window.location.origin).href;
      });
    }

    function roundedRect(context, x, y, width, height, radius) {
      const r = Math.min(radius, width / 2, height / 2);
      context.beginPath();
      context.moveTo(x + r, y);
      context.arcTo(x + width, y, x + width, y + height, r);
      context.arcTo(x + width, y + height, x, y + height, r);
      context.arcTo(x, y + height, x, y, r);
      context.arcTo(x, y, x + width, y, r);
      context.closePath();
    }

    function drawContain(context, image, x, y, width, height) {
      const scale = Math.min(width / image.width, height / image.height);
      const renderedWidth = image.width * scale;
      const renderedHeight = image.height * scale;
      context.drawImage(image, x + (width - renderedWidth) / 2, y + (height - renderedHeight) / 2, renderedWidth, renderedHeight);
    }

    function textLines(context, text, maxWidth, maxLines) {
      const words = String(text || '').split(/\s+/).filter(Boolean);
      const lines = [];
      let line = '';
      let truncated = false;

      words.forEach((word) => {
        const test = line ? `${line} ${word}` : word;
        if (context.measureText(test).width <= maxWidth || !line) {
          line = test;
        } else if (lines.length < maxLines - 1) {
          lines.push(line);
          line = word;
        } else {
          truncated = true;
        }
      });

      if (line && lines.length < maxLines) lines.push(line);
      if (truncated && lines.length) lines[lines.length - 1] = `${lines[lines.length - 1]}…`;
      return lines;
    }

    function productData(root) {
      const relativeUrl = root.dataset.productUrl || '';
      return {
        mode: root.dataset.storyMode || 'product',
        title: (root.dataset.productTitle || '').trim(),
        description: (root.dataset.productDescription || '').trim(),
        price: (root.dataset.productPrice || '').trim(),
        priceCents: Number(root.dataset.productPriceCents || 0),
        comparePrice: (root.dataset.productComparePrice || '').trim(),
        image: (root.dataset.productImage || '').trim(),
        url: relativeUrl ? new URL(relativeUrl, window.location.origin).href : window.location.href
      };
    }

    function storyText(mode) {
      if (mode === 'audio') return { badge: 'Audio nümunəsi', cta: 'SƏSİNİ DİNLƏ' };
      if (mode === 'video') return { badge: 'Video təqdimatı', cta: 'VİDEOYA BAX' };
      return { badge: 'Məhsulu kəşf et', cta: 'ƏTRAFLI BAX' };
    }

    function monthlyCreditText(priceCents) {
      const price = Number(priceCents || 0) / 100;
      if (!price) return '';

      const unofficialRate = 31.6;
      const months = 12;
      const total = price + price * unofficialRate / 100;
      const monthly = total / months;
      const roundedMonthly = Math.ceil(monthly * 10) / 10;

      return `${roundedMonthly.toFixed(2)} ₼ / ${months} ay`;
    }

    function drawCreditPill(context, x, y, text, font) {
      if (!text) return;

      context.save();

      const width = 330;
      const height = 112;
      const centerX = x + width / 2;

      context.shadowColor = 'rgba(23, 163, 74, 0.34)';
      context.shadowBlur = 34;
      context.shadowOffsetY = 14;

      const gradient = context.createLinearGradient(x, y, x + width, y + height);
      gradient.addColorStop(0, '#5df08d');
      gradient.addColorStop(0.45, '#22c55e');
      gradient.addColorStop(1, '#149243');
      roundedRect(context, x, y, width, height, 56);
      context.fillStyle = gradient;
      context.fill();

      context.shadowColor = 'transparent';
      context.shadowBlur = 0;
      context.shadowOffsetY = 0;

      context.fillStyle = 'rgba(255, 255, 255, 0.16)';
      context.beginPath();
      context.arc(x + 34, y + 26, 64, 0, Math.PI * 2);
      context.fill();

      context.fillStyle = 'rgba(255, 255, 255, 0.12)';
      context.beginPath();
      context.arc(x + width - 20, y + height - 18, 72, 0, Math.PI * 2);
      context.fill();

      context.fillStyle = 'rgba(255, 255, 255, 0.86)';
      context.font = `800 20px ${font}`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText('Kreditlə', centerX, y + 34);

      context.fillStyle = '#ffffff';
      context.font = `900 35px ${font}`;
      context.fillText(text, centerX, y + 72);

      context.fillStyle = 'rgba(255, 255, 255, 0.82)';
      context.font = `800 15px ${font}`;
      context.fillText('aylıq ödəniş', centerX, y + 96);

      context.textAlign = 'left';
      context.textBaseline = 'alphabetic';

      context.restore();
    }

    function drawBadge(context, x, y, label, mode, font) {
      context.font = `600 25px ${font}`;
      const width = context.measureText(label).width + 86;

      roundedRect(context, x, y, width, 56, 28);
      context.fillStyle = mode === 'audio' ? 'rgba(217,96,13,.09)' : 'rgba(111,31,48,.08)';
      context.fill();
      context.fillStyle = mode === 'audio' ? '#d9600d' : '#6f1f30';
      context.beginPath();
      context.arc(x + 30, y + 28, 15, 0, Math.PI * 2);
      context.fill();
      context.fillStyle = '#fff';
      context.beginPath();
      context.moveTo(x + 26, y + 20);
      context.lineTo(x + 26, y + 36);
      context.lineTo(x + 38, y + 28);
      context.closePath();
      context.fill();
      context.fillStyle = mode === 'audio' ? '#8a4a12' : '#5f2733';
      context.textBaseline = 'middle';
      context.fillText(label, x + 58, y + 28);
      context.textBaseline = 'alphabetic';
    }

    function drawSaleBadge(context, x, y, font) {
      const label = 'Endirimdə';

      context.save();

      context.font = `900 24px ${font}`;
      const width = context.measureText(label).width + 76;
      const height = 54;

      context.shadowColor = 'rgba(255, 102, 0, 0.24)';
      context.shadowBlur = 22;
      context.shadowOffsetY = 10;

      const gradient = context.createLinearGradient(x, y, x + width, y + height);
      gradient.addColorStop(0, '#ffad63');
      gradient.addColorStop(1, '#ff6600');

      roundedRect(context, x, y, width, height, 27);
      context.fillStyle = gradient;
      context.fill();

      context.shadowColor = 'transparent';
      context.shadowBlur = 0;
      context.shadowOffsetY = 0;

      context.fillStyle = 'rgba(255, 255, 255, 0.18)';
      context.beginPath();
      context.arc(x + 28, y + 27, 36, 0, Math.PI * 2);
      context.fill();

      context.fillStyle = '#ffffff';
      context.font = `900 18px ${font}`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText('%', x + 29, y + 28);

      context.font = `900 24px ${font}`;
      context.textAlign = 'left';
      context.fillText(label, x + 54, y + 28);

      context.restore();
    }

    async function createStoryFile(product) {
      const canvas = document.createElement('canvas');
      canvas.width = 1080;
      canvas.height = 1920;
      const context = canvas.getContext('2d');
      const font = 'Quicksand, -apple-system, BlinkMacSystemFont, sans-serif';
      const copy = storyText(product.mode);

      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, 1080, 1920);
      context.fillStyle = '#faf4ef';
      context.beginPath();
      context.arc(-70, 90, 340, 0, Math.PI * 2);
      context.fill();
      context.fillStyle = '#f8eee7';
      context.beginPath();
      context.arc(1080, 1540, 390, 0, Math.PI * 2);
      context.fill();

      drawBadge(context, 58, 64, copy.badge, product.mode, font);
      if (product.comparePrice) {
        drawSaleBadge(context, 58, 136, font);
      }

      context.fillStyle = '#6f1f30';
      context.font = `700 28px ${font}`;
      context.textAlign = 'center';
      context.fillText('royal.az', 850, 218);
      context.textAlign = 'left';

      if (product.image) {
        try {
          const image = await loadImage(product.image);
          drawContain(context, image, 48, 238, 984, 900);
        } catch (error) {}
      }

      context.strokeStyle = '#eee7e1';
      context.lineWidth = 2;
      context.beginPath();
      context.moveTo(62, 1172);
      context.lineTo(1018, 1172);
      context.stroke();

      context.fillStyle = '#201c1a';
      context.font = `700 52px ${font}`;
      const titleLines = textLines(context, product.title || 'Musiqi aləti', 952, 2);
      titleLines.forEach((line, index) => context.fillText(line, 64, 1260 + index * 62));
      const titleBottom = 1260 + (titleLines.length - 1) * 62;
      const priceY = titleBottom + 86;

      context.fillStyle = '#d9600d';
      context.font = `700 48px ${font}`;
      context.fillText(product.price || '', 64, priceY);

      drawCreditPill(context, 670, priceY - 78, monthlyCreditText(product.priceCents), font);

      if (product.comparePrice) {
        const compareX = 64;
        const compareY = priceY + 39;
        context.fillStyle = '#a89d92';
        context.font = `500 29px ${font}`;
        context.fillText(product.comparePrice, compareX, compareY);
        const compareWidth = context.measureText(product.comparePrice).width;
        context.beginPath();
        context.moveTo(compareX, compareY - 12);
        context.lineTo(compareX + compareWidth, compareY - 12);
        context.strokeStyle = '#a89d92';
        context.stroke();
      }

      context.fillStyle = '#81756c';
      context.font = `500 27px ${font}`;
      const descriptionLines = textLines(context, product.description || 'Məhsul haqqında ətraflı məlumatı kəşf et.', 952, 2);
      const descriptionY = product.comparePrice ? priceY + 84 : priceY + 62;
      descriptionLines.forEach((line, index) => context.fillText(line, 64, descriptionY + index * 38));

      const actionY = 1655;
      roundedRect(context, 64, actionY, 430, 112, 56);
      const gradient = context.createLinearGradient(64, actionY, 494, actionY + 112);
      gradient.addColorStop(0, '#e9872d');
      gradient.addColorStop(1, '#d9600d');
      context.fillStyle = gradient;
      context.fill();
      context.strokeStyle = '#fff';
      context.lineWidth = 3;
      context.beginPath();
      context.arc(124, actionY + 56, 29, 0, Math.PI * 2);
      context.stroke();
      context.fillStyle = '#fff';
      context.beginPath();
      context.moveTo(117, actionY + 42);
      context.lineTo(117, actionY + 70);
      context.lineTo(138, actionY + 56);
      context.closePath();
      context.fill();
      context.font = `700 29px ${font}`;
      context.fillText(copy.cta, 174, actionY + 67);

      context.fillStyle = '#a3968d';
      context.font = `500 23px ${font}`;
      context.fillText(new URL(product.url).hostname, 64, 1850);
      context.textAlign = 'right';
      context.fillText('Royal · Musiqi alətləri mağazası', 1016, 1850);

      const blob = await new Promise((resolve, reject) => {
        canvas.toBlob((result) => result ? resolve(result) : reject(new Error('Story image failed')), 'image/png', 0.95);
      });
      return new File([blob], 'royal-product-story.png', { type: 'image/png' });
    }

    function showStatus(root, message) {
      const status = root.querySelector('[data-product-story-status]');
      if (!status) return;

      status.textContent = message;
      window.setTimeout(() => {
        status.textContent = '';
      }, 2200);
    }

    function closeAllMenus() {
      document.querySelectorAll('[data-product-story-menu]:not([hidden])').forEach((menu) => {
        menu.hidden = true;
        const root = menu.closest('[data-product-story-share]');
        const button = root && root.querySelector('[data-product-story-button]');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }

    async function copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      textarea.remove();
    }

    async function handleStoryShareClick(event) {
      const target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
      if (!target) return;

      const trigger = target.closest('[data-product-story-button]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();

        const root = trigger.closest('[data-product-story-share]');
        if (!root) return;

        const menu = root.querySelector('[data-product-story-menu]');
        if (!menu) return;

        const willOpen = menu.hidden;
        closeAllMenus();
        menu.hidden = !willOpen;
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }

      const option = target.closest('[data-product-share-kind]');
      if (option) {
        event.preventDefault();
        event.stopPropagation();

        const root = option.closest('[data-product-story-share]');
        if (!root) return;

        const menu = root.querySelector('[data-product-story-menu]');
        if (menu) menu.hidden = true;

        const triggerButton = root.querySelector('[data-product-story-button]');
        if (triggerButton) triggerButton.setAttribute('aria-expanded', 'false');

        const product = productData(root);
        const kind = option.dataset.productShareKind;
        const text = `${product.title || 'Bu məhsul'} — Royal.az`;

        if (kind === 'instagram') {
          showStatus(root, 'Story hazırlanır…');
          try {
            const file = await createStoryFile(product);
            if (navigator.share && (!navigator.canShare || navigator.canShare({ files: [file] }))) {
              await navigator.share({ files: [file], title: product.title, text });
            } else {
              const download = document.createElement('a');
              download.href = URL.createObjectURL(file);
              download.download = file.name;
              document.body.appendChild(download);
              download.click();
              download.remove();
              window.setTimeout(() => URL.revokeObjectURL(download.href), 1000);
              showStatus(root, 'Story şəkli endirildi');
            }
          } catch (error) {
            showStatus(root, 'Story hazırlamaq olmadı');
          }
        } else if (kind === 'native') {
          if (navigator.share) {
            try {
              await navigator.share({ title: product.title, text, url: product.url });
            } catch (error) {}
          } else {
            try {
              await copyToClipboard(product.url);
              showStatus(root, 'Link kopyalandı');
            } catch (error) {
              window.open(product.url, '_blank', 'noopener');
            }
          }
        } else if (kind === 'whatsapp') {
          window.open(`https://wa.me/?text=${encodeURIComponent(`${text} ${product.url}`)}`, '_blank', 'noopener');
        } else if (kind === 'telegram') {
          window.open(`https://t.me/share/url?url=${encodeURIComponent(product.url)}&text=${encodeURIComponent(text)}`, '_blank', 'noopener');
        } else if (kind === 'copy') {
          try {
            await copyToClipboard(product.url);
            showStatus(root, 'Link kopyalandı');
          } catch (error) {
            showStatus(root, 'Linki kopyalamaq olmadı');
          }
        }
        return;
      }

      closeAllMenus();
    }

    document.addEventListener('click', handleStoryShareClick, true);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAllMenus();
    });
    document.addEventListener('shopify:section:load', scheduleShareAlignment);
    window.addEventListener('resize', scheduleShareAlignment, { passive: true });
    window.addEventListener('load', scheduleShareAlignment, { once: true });
    scheduleShareAlignment();
  })();
